var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "dynamic-user-container",
      style: {
        "min-height":
          _vm.screenHeight > 800 ? "calc(100vh - 360px)" : "calc(100vh - 286px)"
      }
    },
    [
      _c("div", { staticClass: "btns-group" }, [
        _c(
          "div",
          { staticClass: "btns-group-left" },
          [
            _vm._v(" 筛选人员规则： "),
            _c(
              "el-select",
              {
                attrs: { clearable: "", placeholder: "请选择人员规则" },
                model: {
                  value: _vm.userLabelRuleId,
                  callback: function($$v) {
                    _vm.userLabelRuleId = $$v
                  },
                  expression: "userLabelRuleId"
                }
              },
              _vm._l(_vm.rules, function(item, key) {
                return _c("el-option", {
                  key: key,
                  attrs: { label: item.ruleName, value: item.ruleId }
                })
              }),
              1
            ),
            _c("input", {
              staticClass: "btn btn-red see-btn",
              attrs: {
                slot: "reference",
                type: "button",
                value: "预览人员信息"
              },
              on: {
                click: function($event) {
                  return _vm.previewUser()
                }
              },
              slot: "reference"
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "btns-group-right" },
          [
            _c(
              "el-popover",
              {
                ref: "filter-popover",
                attrs: {
                  placement: "bottom",
                  width: "280",
                  trigger: "click",
                  "popper-class": "filter-popover"
                }
              },
              [
                _c(
                  "el-form",
                  {
                    ref: "filterForm",
                    staticClass: "filterForm",
                    attrs: {
                      model: _vm.filterForm,
                      "label-width": "80px",
                      "label-position": "top"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "用户名称" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              filterable: "",
                              remote: "",
                              "reserve-keyword": "",
                              placeholder: "请输入用户ID或名称",
                              "remote-method": _vm.userRemoteMethod,
                              loading: _vm.userOptionLoading,
                              size: "small",
                              multiple: ""
                            },
                            model: {
                              value: _vm.filterForm.userId,
                              callback: function($$v) {
                                _vm.$set(_vm.filterForm, "userId", $$v)
                              },
                              expression: "filterForm.userId"
                            }
                          },
                          _vm._l(_vm.userOptions, function(item) {
                            return _c("el-option", {
                              key: item.userId,
                              attrs: {
                                label: item.userName + "/" + item.userId,
                                value: item.userId
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "所属机构" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择活动区域" },
                            model: {
                              value: _vm.filterForm.orgMap,
                              callback: function($$v) {
                                _vm.$set(_vm.filterForm, "orgMap", $$v)
                              },
                              expression: "filterForm.orgMap"
                            }
                          },
                          _vm._l(_vm.userFilterData.orgMap, function(item) {
                            return _c("el-option", {
                              key: item.key,
                              attrs: {
                                multiple: "",
                                label: item.value,
                                value: item.key
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm.basicInfoFormData.canSetManageOrg === 1
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "管辖部门" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  multiple: "",
                                  placeholder: "请选择管辖部门"
                                },
                                model: {
                                  value: _vm.filterForm.manageOrgMap,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.filterForm,
                                      "manageOrgMap",
                                      $$v
                                    )
                                  },
                                  expression: "filterForm.manageOrgMap"
                                }
                              },
                              _vm._l(_vm.userFilterData.manageOrgMap, function(
                                item
                              ) {
                                return _c("el-option", {
                                  key: item.key,
                                  attrs: { label: item.value, value: item.key }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.basicInfoFormData.canSetBizLine === 1
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "管辖条线" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  multiple: "",
                                  placeholder: "请选择管辖条线"
                                },
                                model: {
                                  value: _vm.filterForm.bizLineList,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filterForm, "bizLineList", $$v)
                                  },
                                  expression: "filterForm.bizLineList"
                                }
                              },
                              _vm._l(_vm.userFilterData.bizLineList, function(
                                item
                              ) {
                                return _c("el-option", {
                                  key: item.key,
                                  attrs: { label: item.value, value: item.key }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticStyle: { "text-align": "center" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "cancelBtn cancelOrRestBtnHover",
                            on: {
                              click: function($event) {
                                return _vm.resetFilterConfirm()
                              }
                            }
                          },
                          [_vm._v("重置")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              "margin-left": "16px",
                              width: "50px",
                              height: "24px",
                              padding: "0px",
                              "min-width": "50px",
                              "font-size": "12px"
                            },
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.filterConfirm()
                              }
                            }
                          },
                          [_vm._v("确定")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("input", {
                  staticClass: "btn btn-red filter-btn",
                  attrs: { slot: "reference", type: "button", value: "筛选" },
                  on: {
                    click: function($event) {
                      return _vm.getUserFilterData()
                    }
                  },
                  slot: "reference"
                })
              ],
              1
            ),
            _c("input", {
              staticClass: "btn btn-red export-btn",
              attrs: { type: "button", value: "导出" },
              on: {
                click: function($event) {
                  return _vm.exportUsers()
                }
              }
            }),
            _c("input", {
              staticClass: "btn btn-red btn-edit",
              attrs: { type: "button", value: "批量维护用户" },
              on: {
                click: function($event) {
                  return _vm.handleUploadUser()
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "el-table",
        {
          ref: "autoUserTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.autoUsers,
            border: "",
            "tooltip-effect": "dark",
            height:
              _vm.screenHeight > 800
                ? "calc(100vh - 520px)"
                : "calc(100vh - 440px)"
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "userIdAndName",
              label: "用户",
              width: "250",
              "show-overflow-tooltip": ""
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "mngLevel",
              label: "职级",
              width: "200",
              "show-overflow-tooltip": ""
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "jobNameList",
              label: "职位",
              "show-overflow-tooltip": ""
            }
          }),
          _c(
            "el-table-column",
            {
              attrs: { prop: "corner", "show-overflow-tooltip": "" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: { effect: "dark", placement: "top" }
                        },
                        [
                          _c("div", {
                            attrs: { slot: "content" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.ToBreak(scope.row.corner + "角")
                              )
                            },
                            slot: "content"
                          }),
                          _c("div", { staticClass: "line" }, [
                            _vm._v(_vm._s(scope.row.corner) + "角")
                          ])
                        ]
                      )
                    ]
                  }
                }
              ])
            },
            [
              _c("template", { slot: "header" }, [
                _c("span", { staticClass: "header-ellipsis font14" }, [
                  _vm._v("AB角")
                ])
              ])
            ],
            2
          ),
          _c("el-table-column", {
            attrs: {
              prop: "pathName",
              label: "所属机构",
              "show-overflow-tooltip": ""
            }
          }),
          _vm.basicInfoFormData.canSetManageOrg === 1
            ? _c("el-table-column", {
                attrs: {
                  prop: "manageOrgName",
                  label: "管辖部门",
                  "show-overflow-tooltip": ""
                }
              })
            : _vm._e(),
          _vm.basicInfoFormData.canSetBizLine === 1
            ? _c("el-table-column", {
                attrs: {
                  prop: "bizLineName",
                  label: "管辖条线",
                  "show-overflow-tooltip": ""
                }
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: {
              prop: "createdTime",
              label: "创建时间",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " + _vm._s(scope.row.createdTime.substring(0, 10)) + " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "createdBy",
              label: "创建人",
              "show-overflow-tooltip": ""
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "updatedTime",
              label: "最后更新时间",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      " " + _vm._s(scope.row.updatedTime.substring(0, 10)) + " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "updatedBy",
              label: "最后更新人",
              "show-overflow-tooltip": ""
            }
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "op-edit",
                        staticStyle: {
                          cursor: "pointer",
                          color: "var(--mainColor)"
                        },
                        on: {
                          click: function($event) {
                            return _vm.editUser(scope)
                          }
                        }
                      },
                      [_vm._v(" 编辑 ")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "footer-pageDynamic" },
        [
          _c(
            "div",
            { staticClass: "footer-btn-group" },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn btn-red cancel-btn",
                  attrs: { slot: "reference" },
                  on: {
                    click: function($event) {
                      return _vm.confirmCancel(true)
                    }
                  },
                  slot: "reference"
                },
                [_vm._v(" 取消 ")]
              ),
              _c("input", {
                staticClass: "btn btn-red submit-btn",
                staticStyle: { "margin-left": "20px" },
                attrs: { slot: "reference", type: "button", value: "提交" },
                on: {
                  click: function($event) {
                    return _vm.submit()
                  }
                },
                slot: "reference"
              })
            ],
            1
          ),
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pagination.total,
              "current-page": _vm.pagination.pageNum,
              "page-sizes": [10, 20, 50, 100, 1000, 2000],
              "hide-on-single-page": false
            },
            on: {
              "update:currentPage": function($event) {
                return _vm.$set(_vm.pagination, "pageNum", $event)
              },
              "update:current-page": function($event) {
                return _vm.$set(_vm.pagination, "pageNum", $event)
              },
              "current-change": _vm.currentChange,
              "size-change": _vm.sizeChange
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog_footer_btn",
          attrs: {
            width: "560px",
            title: "编辑用户",
            visible: _vm.updateUserDialogShow
          },
          on: {
            "update:visible": function($event) {
              _vm.updateUserDialogShow = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "dialog-body" },
            [
              _c(
                "el-form",
                {
                  ref: "userForm",
                  attrs: {
                    "label-position": "top",
                    model: _vm.singleUserForm,
                    "label-width": "150px"
                  }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 40 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "用户编号：", prop: "userId" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    filterable: "",
                                    remote: "",
                                    "reserve-keyword": "",
                                    placeholder: "请输入用户ID或名称",
                                    "remote-method": _vm.userRemoteMethod,
                                    loading: _vm.userOptionLoading,
                                    size: "small",
                                    disabled: ""
                                  },
                                  on: { change: _vm.setUserDefaultInfo },
                                  model: {
                                    value: _vm.singleUserForm.userId,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.singleUserForm,
                                        "userId",
                                        $$v
                                      )
                                    },
                                    expression: "singleUserForm.userId"
                                  }
                                },
                                _vm._l(_vm.userOptions, function(item) {
                                  return _c("el-option", {
                                    key: item.userId,
                                    attrs: {
                                      label: item.userName + "/" + item.userId,
                                      value: item.userId
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "用户名称：", prop: "userName" }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "small",
                                  maxlength: "32",
                                  "show-word-limit": "",
                                  placeholder: "请输入用户名称",
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.singleUserForm.userName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.singleUserForm,
                                      "userName",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "singleUserForm.userName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 40 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "职级", prop: "mngLevel" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "small",
                                  placeholder: "请输入用户职级",
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.singleUserForm.mngLevel,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.singleUserForm,
                                      "mngLevel",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "singleUserForm.mngLevel"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "职位", prop: "position" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "small",
                                  placeholder: "请输入用户职位",
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.singleUserForm.position,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.singleUserForm,
                                      "position",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "singleUserForm.position"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 40 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "所属机构", prop: "org" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "small",
                                  placeholder: "请输入所属机构",
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.singleUserForm.org,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.singleUserForm,
                                      "org",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "singleUserForm.org"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "AB角", prop: "corner" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择AB角" },
                                  model: {
                                    value: _vm.singleUserForm.corner,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.singleUserForm,
                                        "corner",
                                        $$v
                                      )
                                    },
                                    expression: "singleUserForm.corner"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    key: "A",
                                    attrs: { label: "A角", value: "A" }
                                  }),
                                  _c("el-option", {
                                    key: "B",
                                    attrs: { label: "B角", value: "B" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 40 } },
                    [
                      _vm.basicInfoFormData.canSetManageOrg === 1
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "管辖部门",
                                    prop: "manageOrgList"
                                  }
                                },
                                [
                                  _c("org-select", {
                                    attrs: {
                                      "need-path-id": true,
                                      "close-popover-flag": false,
                                      modal: false,
                                      "is-show-all-path": false,
                                      "root-org-id": _vm.topId,
                                      multiple: true,
                                      placeholder: "请选择管辖部门"
                                    },
                                    on: {
                                      userSelectChange: _vm.userSelectChange,
                                      input: _vm.orgHandle
                                    },
                                    model: {
                                      value: _vm.singleUserForm.manageOrgList,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.singleUserForm,
                                          "manageOrgList",
                                          $$v
                                        )
                                      },
                                      expression: "singleUserForm.manageOrgList"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.basicInfoFormData.canSetBizLine === 1
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "管辖条线", prop: "ab" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        multiple: "",
                                        placeholder: "请选择管辖条线"
                                      },
                                      model: {
                                        value: _vm.singleUserForm.bizLineList,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.singleUserForm,
                                            "bizLineList",
                                            $$v
                                          )
                                        },
                                        expression: "singleUserForm.bizLineList"
                                      }
                                    },
                                    _vm._l(_vm.bizLineList, function(item) {
                                      return _c("el-option", {
                                        key: item.key,
                                        attrs: {
                                          value: item.key,
                                          label: item.value
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "dialog-footer" },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  on: {
                    click: function($event) {
                      _vm.updateUserDialogShow = false
                    }
                  }
                },
                [_vm._v(" 取消 ")]
              ),
              _c("input", {
                staticClass: "btn btn-red",
                attrs: { type: "button", value: "确认" },
                on: {
                  click: function($event) {
                    return _vm.confirmUpdateUser("formRole")
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog_footer_btn",
          attrs: {
            width: "560px",
            title: "批量维护",
            visible: _vm.uploadDialogShow
          },
          on: {
            "update:visible": function($event) {
              _vm.uploadDialogShow = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "dialog-body" },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between"
                  }
                },
                [
                  _c("span", [_vm._v("上传文件：")]),
                  _c(
                    "span",
                    {
                      staticStyle: { color: "#4f9cf1", cursor: "pointer" },
                      on: {
                        click: function($event) {
                          return _vm.downloadTpl()
                        }
                      }
                    },
                    [_vm._v("下载模板")]
                  )
                ]
              ),
              _c("FileUpload", {
                ref: "attachments",
                staticClass: "file-upload",
                staticStyle: { "margin-top": "10px" },
                attrs: {
                  type: "ATTACHMENT",
                  url: "/platform/customizedUser/batchImport",
                  "format-text": ".xlsx",
                  accept: ".xlsx",
                  "upload-data": {
                    roleId: this.basicInfoFormData.roleId,
                    systemId: this.basicInfoFormData.systemId
                  }
                },
                on: {
                  uploadSuccess: function($event) {
                    return _vm.uploadSuccess($event)
                  },
                  uploadError: function($event) {
                    return _vm.uploadError($event)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "dialog-footer" },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  on: {
                    click: function($event) {
                      _vm.fileList = []
                      _vm.uploadDialogShow = false
                    }
                  }
                },
                [_vm._v(" 取消 ")]
              ),
              _c("input", {
                staticClass: "btn btn-red",
                attrs: { type: "button", value: "确认" },
                on: { click: _vm.handleConfirmUpload }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            title: "导出错误文件",
            width: "30%",
            center: "",
            visible: _vm.downloadErrorDialogVisible
          },
          on: {
            "update:visible": function($event) {
              _vm.downloadErrorDialogVisible = $event
            }
          }
        },
        [
          _c("span", [
            _c(
              "p",
              {
                staticClass: "link",
                on: {
                  click: function($event) {
                    return _vm.downloadError()
                  }
                }
              },
              [_vm._v("点击下载文件")]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }